import { render, staticRenderFns } from "./art.vue?vue&type=template&id=56c19699&scoped=true&"
import script from "./art.vue?vue&type=script&lang=js&"
export * from "./art.vue?vue&type=script&lang=js&"
import style0 from "./art.vue?vue&type=style&index=0&id=56c19699&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c19699",
  null
  
)

export default component.exports